import { render, staticRenderFns } from "./softList.vue?vue&type=template&id=3ef90bb0&scoped=true"
import script from "./softList.vue?vue&type=script&lang=js"
export * from "./softList.vue?vue&type=script&lang=js"
import style0 from "./softList.vue?vue&type=style&index=0&id=3ef90bb0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef90bb0",
  null
  
)

export default component.exports